module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "250px"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "12%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "36%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "50%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('td', [_vm._v("Family ")]), _vm._v(" "), _c('td', [_vm._v("Surviving brother ")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("V.K.N. Murthy Sikha")])])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Son")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Naresh Sikha")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Daughter-in-law")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Anna (Annapoorna Malyala) Sikha")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Grandson")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Ishwar Satyanand Sikha")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Daughter")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Neela Moorty Mummaneni")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Son-in-law")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Bobby Mummaneni")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Granddaughter")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Priya Mummaneni")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Grandson")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Jay Ramprasad Mummaneni")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Friends")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Jim and Terri Cotts")]), _vm._v(" "), _c('p', [_vm._v("Jim Aton and Carrie Trenholm")]), _vm._v(" "), _c('p', [_vm._v("Roger Anderson and Sandy Gillies")]), _vm._v(" "), _c('p', [_vm._v("Ed McNicoll")]), _vm._v(" "), _c('p', [_vm._v("Eric Morrow")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Mentors")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("The late Dr. Jack Adamson")]), _vm._v(" "), _c('p', [_vm._v("The late Dr. William Mulder")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("My students")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("and Lakshmi Sikha Moorty")]), _vm._v(" "), _c('td')])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2100e44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch003.vue
// module id = 69
// module chunks = 0